export default {"src":"/_next/static/media/hide.f1d01d61.svg","height":24,"width":28};